export default __webpack_public_path__ + "static/kb_3_18-62e2a9a62ce6521215449ca6c726ffcb.jpg";